import { render, staticRenderFns } from "./AnnouncementOpen.html?vue&type=template&id=6af32780&scoped=true&external"
import script from "./AnnouncementOpen.vue?vue&type=script&lang=js"
export * from "./AnnouncementOpen.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementOpen.scss?vue&type=style&index=0&id=6af32780&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af32780",
  null
  
)

export default component.exports